var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCirclefacebookicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_11389)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 28C6.2692 28 0 21.7308 0 14C0 6.2692 6.2692 0 14 0C21.7308 0 28 6.2692 28 14C28 21.7308 21.7308 28 14 28Z",
    fill: "#3B579D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6396 27.9999V17.1555H21.2796L21.8256 12.9303H17.6396V10.2311C17.6396 9.00751 17.9784 8.17311 19.734 8.17311H21.9712V4.39591C21.5848 4.34551 20.2548 4.23071 18.7092 4.23071C15.4836 4.23071 13.2744 6.19911 13.2744 9.81671V12.9331H9.62598V17.1583H13.2744V27.9999H17.6396Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_11389"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclefacebookicon);
export default __webpack_public_path__ + "static/media/circlefacebookicon.2437bf49e3c7f7df0a02b06c121b7198.svg";
export { ForwardRef as ReactComponent };